export default {
    company: {
        name: "Yibin Paper Co., Ltd."
    },
    nav: {
        home: "Home",
        about: "About Us",
        products: "Products",
        contact: "Contact Us",
        sustainability: "Sustainability",
        technology: "Technology & Innovation"
    },
    banner: {
        title: "Crafting Elegance, Weaving Green",
        subtitle: "Carrying Forward Millennia-Old Papermaking Craftsmanship, Pioneering New Standards in Bamboo Pulp Papermaking"
    },
    products: {
        subtitle: "Premium Bamboo Pulp Paper Products for Diverse Needs",
        description: "We Deliver comprehensive paper solutions, from Base Paper to Finished Products, catering to all your requirements",
        viewDetails: "Learn More",
        categories: {
            title: "Product Series",
            subtitle: "Bamboo Pulp Paper Products: Leading the New Trend in Green Consumption",
            livingPaper: "Household Paper Base Paper",
            livingPaperDesc: "Household Paper Base Paper Series",
            foodPaper: "Food Packaging Base Paper",
            foodPaperDesc: "Food Packaging Base Paper Series",
            finishedProducts: "Finished Household Paper Series"
        },
        advantages: {
            title: "Product Advantages",
            subtitle: "Renew Life in the Name of Bamboo"
        },
        applications: {
            title: "Applications",
            subtitle: "Widely Used in Daily Life and Diverse Industries"
        },
        cta: {
            title: "Need custom product solutions?",
            description: "We offer professional bamboo pulp paper product customization services tailored to your needs.",
            buttonText: "Contact Us"
        },
        detail: {
            features: 'Product Features',
            contactUs: 'Contact Us',
            specifications: 'Product Specifications',
            usageScenarios: 'Usage Scenarios',
            relatedProducts: 'Related Products',
            cta: {
                title: 'Need more product information?',
                description: 'Our Product Consultants are ready to provide expert advice and custom solutions',
                buttonText: 'Contact Us'
            }
        },
        title: "Main Products"
    },
    advantages: {
        title: "Our Strengths",
        subtitle: "Bamboo Pulp Papermaking: Eco-Technology, Superior Quality",
        items: {
            experience: {
                title: "Profound Industry Experience",
                description: "80 years of technical expertise. A complete pulp & paper and supporting industrial chain providing solid technical support for green, low-carbon bio-based material transformation."
            },
            production: {
                title: "Mature & Scalable Production System",
                description: "Comprehensive production facilities & automated lines enable rapid response to customer needs and cost-effective, high-efficiency mass production."
            },
            innovation: {
                title: "Collaborative R&D Innovation (Industry-University-Research)",
                description: "Joint labs with universities & research institutes focus on low-carbon processes and renewable materials R&D, accelerating industrialization of cutting-edge technologies like bio-based materials."
            },
            certification: {
                title: "Full-Chain Green Certifications",
                description: "Certifications (FSC, Healthcare Grade, Hygiene & Safety Products) covering raw material sourcing to production enhance product market competitiveness."
            }
        }
    },
    footer: {
        contact: "Contact Us",
        address: "Address: Yibin Paper Co., Ltd., Peishi Light Industrial Park, Nanxi District, Yibin, Sichuan Province",
        phone: "Tel: +86-0831-3309663",
        email: "Email: ybzy@yb-zy.com",
        quickLinks: "Quick Links",
        moreInfo: "More Information",
        news: "News",
        careers: "Careers",
        informations:"Information Disclosure",
        followUs: "Follow Us",
        wechat: "WeChat Official Account: Yibin Paper",
        rights: "Copyright",
        slogan: "Bamboo Pulp Papermaking: Green Innovation",
        ICPfiling: "蜀ICP备05027078号-1",
        PublicSecurityFiling: "川公网安备51150302000130号"
    },
    about: {
        companyProfile: "Company Profile",
        established: "Founded in 1944",
        formerName: `Formerly Known as 'China Paper Mill'`,
        firstNewsprint: "Birthplace of China's First Machine-Made Newsprint",
        listed: "Listed on the Shanghai Stock Exchange in 1997 (Stock Code: 600793)",
        firstListed: "First Listed Company in China's Paper Industry",
        firstYibinListed: "First Listed Company in Yibin City",
        wuliangyeSubsidiary: "Subsidiary of Wuliangye Group Co., Ltd.",
        firstNewMeterial: `Chain Owner Enterprise in the First Batch of  "60+10"  New Bamboo Material Flagship Product Chains`,
        capacity: "Production Capacity",
        mainCapacity: "Headquarters Pulp & Paper Capacity: 540,000 tons/year",
        managedCapacity: "Managed Companies Pulp & Paper Capacity: 120,000 tons/year",
        newMaterialCapacity: "New Material Corrugated Box Capacity: 100 million m²/year",
        bambooMoldingCapacity: "New Material Bamboo Pulp Molding Capacity: 6,600 tons/year",
        celluloseCapacity: "Cellulose Acetate Capacity: 30,000 tons/year",
        historyTitle: "History",
        historySubtitle: "Seven Decades of Dedication Forging a Bamboo Pulp Papermaking Brand",
        historyItems: {
            "1944": "Founding of China Paper Mill, marking the start of China's paper industry history",
            "1945": "Successfully Produced China's First 100% Mechanical Wood Pulp Newsprint",
            "1950": `Renamed to 'Yibin Paper Mill'`,
            "1961": "Chairman Zhu De Visited the Mill",
            "1966": "Marshal Peng Dehuai  Visited the Mill",
            "1988": "Piloted Shareholding System Reform, established 'Yibin Paper Co., Ltd.'",
            "1997": "Listed on the Shanghai Stock Exchange",
            "2012": "Groundbreaking Ceremony for Yibin Paper's Complete Relocation",
            "2015": "New Zone Food Packaging Base Paper Line Completed & Operational",
            "2018_1": "New Zone Household Paper Line Completed & Operational",
            "2018_2": "Subsidiary of Wuliangye Group Co., Ltd.",
            "2025": "Embarking on a Strategic Path to Transform from Traditional Papermaking into a Comprehensive Green Carbon Special Bio-based Materials Group"
        },
        futureDevelopment: "Future Development",
        future: {
            point1: "Focusing Fully on Development Goals",
            point2: "Leveraging the Unique Advantages of Bamboo Resources",
            point3: "Accelerating Transformation Towards Specialized, High-Tech, High-Value-Added Businesses",
            point4: "Striving to Become a World-Class Niche Leader in Paper Product Segments"
        },
        coreValues: "Corporate Philosophy",
        coreValuesSubtitle: "Bamboo as Bone, Paper as Soul, Green Innovation Drives Development",
        values: {
            mission: "Corporate Mission",
            missionLine1: "Building on Bio-based New Materials",
            missionLine2: "Creating a Better Green Carbon World",
            vision: "Corporate Vision",
            visionLine1: "Building a Green Carbon Special Bio-Based",
            visionLine2: "Materials Industrial Group",
            coreValues: "Core Values",
            coreValuesLine1: "Quality First, Innovation-Driven",
            coreValuesLine2: "Green Development, Win-Win Co-Creation",
            philosophy: "Business Philosophy",
            philosophyLine1: "Customer-Centric",
            philosophyLine2: "Quality as Foundation, Innovation as Driver"
        },
        certificationsTitle: "Certifications",
        certificationsSubtitle: "Quality Assurance, Industry Recognition",
        certificationItems: {
            fsc: "FSC® Certification (Forest Stewardship Council®)",
            fscDesc: "FSC® Certified, Sourcing from Responsibly Managed Forests",
            iso9001: "ISO 9001 Certification",
            iso9001Desc: "International Quality Management System Certification",
            iso14001: "FSSC 22000 Certification",
            iso14001Desc: "Food Safety System Certification",
            medical: "Medical-Grade Product Certification",
            medicalDesc: "Medical-Grade Product Certification",
            antibacterial: "Antibacterial & Hygiene Certification",
            antibacterialDesc: "Antibacterial & Hygiene Certification",
            safety: "Hygiene & Safety Product Certification",
            safetyDesc: "Hygiene & Safety Product Certification"
        },
        honorsTitle: "Corporate Honors",
        honorsSubtitle: "Quality Assurance, Industry Recognition",
        honorItems: {
            greenFactory: "National Green Factory",
            greenFactoryDesc: "Green Manufacturing Benchmark Enterprise (MIIT)",
            forestryLeader: "National Key Forestry Leading Enterprise",
            forestryLeaderDesc: "Key Leading Enterprise Designation (National Forestry and Grassland Administration)",
            agriculturalProduct: "China Outstanding Agricultural Enterprise",
            agriculturalProductDesc: "China Outstanding Agricultural Enterprise Brand",
            lightIndustry: "National Advanced Collective in Light Industry",
            lightIndustryDesc: "National Advanced Collective in Light Industry",
            bambooProduct: "Top 10 Bamboo Product Enterprise",
            bambooProductDesc: "Top 10 Enterprise of  Bamboo Industry Brand in China",
            engineeringCenter: "Paper Engineering Technology Research Center",
            engineeringCenterDesc: "Sichuan Provincial Bamboo Pulp & Paper Engineering Technology Research Center"
        },
        productHonorsTitle: "Product Honors",
        productHonorsSubtitle: "Quality Assurance, Industry Recognition",
        productHonorItems: {
            industryExcellence: "Industry Craftsmanship Product Award",
            neZhaExcellence: "Nezha Series: 2025 China Household Paper Industry Craftsmanship Product Award",
            moDiKaExcellence: "Modica Series: China Household Paper Industry Craftsmanship Product Award",
            bambooExpoGold: "International Bamboo Expo Gold Award",
            moDiKaGold: "Modica Series: 2025 International Bamboo Expo Gold Award",
            shanghaiExpoGold: "International Bamboo Expo Gold Award",
            jinZhuGold: "Gold Bamboo Natural Series: 2020 Shanghai International Bamboo Expo Gold Award",
            quanZhuGold: "All-Bamboo Packaging Base Paper: 2018 Shanghai International Bamboo Expo Gold Award",
            westernExpoGold: "China Western Forestry Industry Expo Gold Award",
            jinZhuWesternGold: "Gold Bamboo Natural Series: China Western Forestry Expo Gold Award"
        },
        cta: {
            title: "Join Yibin Paper, Co-Create a Green Future",
            description: "We look forward to collaborating with you to drive sustainable development in the bamboo pulp papermaking industry",
            buttonText: "Contact Us"
        }
    },
    technology: {
        title: 'Technology & Innovation',
        subtitle: 'Technology Leads, Green Innovation Builds a New Benchmark in Bamboo Pulp Papermaking',
        innovation: {
            title: 'Innovation-Driven Development',
            subtitle: 'Technology Leads, Green Innovation Builds a New Benchmark in Bamboo Pulp Papermaking',
            management: {
                title: 'Efficiently & Coordinated Innovation Management System',
                content: 'Yibin Paper regards technological innovation as the core driver of its development. The company has established a Strategy & Development Committee to coordinate R&D, production, and marketing.  Building an innovation framework featuring a "Headquarters R&D Center + Production Bases" structure, supported by flexible incentive mechanisms to ensure streamlines efficient implementation from innovation to industrialization.'
            },
            team: {
                title: 'Professional Teams Leading Technological Breakthroughs',
                content: 'Leveraging provincial innovation platforms & R&D Teams, We maintain close collaboration with prestigious universities and research institutes. Focused R&D Projects in Low-Carbon Pulping, Bio-based Materials, etc., Provide Strong momentum for innovation.'
            },
            results: {
                title: 'Innovation Outcomes Empower Industrial Upgrade',
                content: 'Mastering core technologies across the bamboo pulping and papermaking chain. Breakthroughs continuously in green pulping, clean production, and resource utilization through innovation. Leading the company transition to a green, low-carbon bio-based materials industry.'
            }
        },
        core: {
            title: 'Core Technologies',
            subtitle: 'Technology Leads, Green Innovation',
            tabs: {
                pulping: 'Bamboo Pulping Technology',
                bleaching: 'Circular Economy Core Technologies',
                papermaking: 'Green Product Innovation Technology'
            },
            items: {
                pulping: {
                    details: [
                        {
                            title: 'Bamboo Pre-treatment Technology System',
                            content: 'Overcoming challenges in processing high-density, high-silica bamboo. Developed homogeneous bamboo impregnation technology, reducing energy consumption by over 10%.'
                        },
                        {
                            title: 'Low-Carbon Clean Pulping Technology',
                            content: '"Deep Delignification - ECF Bleaching" process reduces AOX Emissions >30% Lower than national standard. Integrated "Anaerobic+Aerobic+Fenton" Water treatment reduces COD Emissions >50% Lower than national standard.'
                        }
                    ]
                },
                bleaching: {
                    details: [
                        {
                            title: 'Full Bamboo Component Utilization Technology',
                            content: 'Bamboo Cellulose for Pulp & Paper; Black Liquor Lignin Combusted for Heat Recovery (350kWh/Ton Pulp); Pulping Residues Converted to Biofertilizers.'
                        }
                    ]
                },
                papermaking: {
                    details: [
                        {
                            title: 'Functional Bamboo Fiber Products',
                            content: "Bamboo fiber reinforcement tech boosts Tensile & Folding strength of packaging paper by >50%. Self-antibacterial household Paper leverages bamboo's natural antibacterial properties, enhancing efficiency by >90% under same conditions."
                        },
                        {
                            title: 'Bio-based New Materials',
                            content: 'Bamboo fiber products replace plastics, reducing carbon footprint by 60%.'
                        }
                    ]
                }
            }
        },
        research: {
            title: 'R&D Center',
            subtitle: 'Dedicated to R&D, Creating Value',
            imageAlt: 'Yibin Paper R&D Center',
            center: {
                title: 'R&D Innovation Platform',
                content: "Founded in 2003, the R&D Center drives Yibin Paper's technological innovation. It focuses on industry trends and commercializing research outcomes. Recognized as a Provincial Enterprise Technology Center, it operates two provincial-level innovation platforms, including the Sichuan Bamboo Pulp & Paper Engineering Technology Research Center.The Center leads the Bamboo Industry-Education-Research Consortium and participates in the National Key R&D Program on bamboo pulp-paper integration.With extensive experience in key bamboo pulp-paper technologies, the company has developed distinct competitive advantages."
            },
            cooperation: {
                title: 'Collaborative R&D',
                content: 'Long-term partnerships with Sichuan Ag. Univ., SCUT, BFU, NFU, CAF, etc., involve joint national/provincial research projects, deepening industry-academia-research integration.'
            }
        },
        patents: {
            title: 'Patents & Achievements',
            subtitle: 'Technology Accumulation, Industry Leadership',
            authorized: {
                title: 'Authorized Patents',
                items: [
                    'A Refined Mixed Bamboo Pulp, Its Preparation Method, and Application in Papermaking',
                    'A Refined Bamboo Pulp, Its Preparation Method, and Application in Papermaking',
                    'A Black Liquor Spray Gun for Recovery Boilers',
                    'A Fiber Screening Device'
                ]
            },
            projects: {
                title: 'Research Projects',
                items: [
                    'Clean & Energy-Efficient manufacturing of High Bulk & Strength bamboo pulp and High-Strength packaging board blending tech',
                    'Purification of Bamboo Chemical Pulp and Blending Tech for Premium Household Paper',
                    'R&D on Deep Processing Tech for Bamboo-Based Pulp',
                    'R&D on High-Quality Bamboo-Based Cellulose Fiber',
                    'R&D on High-Value Functional Lignin Products'
                ]
            },
            awards: {
                title: 'Science & Technology Awards',
                items: [
                    'Sichuan Provincial Science & Technology Progress Award (First Class)'
                ]
            },
            papers: {
                title: 'Research Papers',
                items: [
                    'Determination of Total Rosin and Aluminum Sulfate Content in Cationic Dispersed Rosin Emulsion',
                    'Trial Production of Natural Food Cardboard Containing Bamboo CTMP',
                    'Application of Cooking Additives in DDS Cooking of Whole Bamboo',
                    'New Process for Efficient Bamboo Fiber Utilization in Dissolving Pulp via Fiber Fractionation: Lab Study & Plant Trials',
                    'Tandem strategy of photocatalytic preoxidation-Ultrasonic Cavitation Depolymerization Cascade Strategy for High-Value Lignin Utilization'
                ]
            }
        },
        projects: {
            title: 'Innovation Projects',
            subtitle: 'Leading the Future Industry Direction',
            items: [
                {
                    title: 'Integration & Demonstration of Key Technologies for Sichuan Bamboo Industry Chain',
                    period: '2019-2022',
                    cooperation: 'Sichuan Agricultural University',
                    desc: 'Integrating bamboo resource and industrial chains to promote industry development.'
                },
                {
                    title: 'Construction & Demonstration of High-Tech Innovation Platform for Yibin Forest-Bamboo Industry',
                    period: '2019-2022',
                    cooperation: 'South China University of Technology (SCUT)',
                    desc: 'Breakthroughs in low-sulfur bamboo cooking and high-value black liquor utilization.'
                },
                {
                    title: 'R&D on Deep Processing Tech for Bamboo-Based Pulp',
                    period: '2022-2024',
                    cooperation: 'Chinese Academy of Forestry (CAF)',
                    desc: 'Breaking key techs like high-yield bamboo pulping for industrialization and import substitution.'
                },
                {
                    title: 'R&D on High-Value Functional Lignin Products',
                    period: '2022-2024',
                    cooperation: 'Beijing Forestry University (BFU)',
                    desc: 'Fractionating lignin from bamboo pulping black liquor for by-products, enabling high-value utilization.'
                },
                {
                    title: 'Research on Key Technologies for Bamboo-Pulp-Paper Integration',
                    period: '2023-2028',
                    cooperation: 'Chinese Academy of Forestry (CAF)',
                    desc: 'Key techs: efficient uniform impregnation softening, precise low-energy refining, alkaline hydrogen peroxide activation bleaching.'
                },
                {
                    title: 'Research & Integrated Demonstration of Key Technologies for Smart Bamboo Industry',
                    period: '2024-2027',
                    cooperation: 'Nanjing Forestry University (NFU)',
                    desc: 'Research on Key Challenges: Clean Manufacturing & Resource Utilization in Bamboo Pulp Paper Mills.'
                }
            ]
        },
        cta: {
            title: 'Co-exploring the Future of Bamboo Pulp Papermaking',
            subtitle: 'Partners passionate about bamboo pulp paper tech innovation are welcome to contact us for joint industry advancement',
            button: 'Contact Us'
        }
    },
    sustainability: {
        title: 'Sustainability',
        subtitle: 'Bamboo as Base, Innovation as Wing: Building a Green, Low-Carbon Bio-based Materials Industry Benchmark',
        vision: {
            title: 'Sustainability Vision',
            content: 'Bamboo as Base, Innovation as Wing: Building a Green, Low-Carbon Bio-based Materials Industry Benchmark',
            imageAlt: 'Yibin Paper Sustainability Vision',
            intro1: 'As an Innovator in the Bamboo Pulp Papermaking Industry,',
            intro2: "Yibin Paper adheres to 'Efficient Bamboo Resource Utilization + Low-Carbon Tech' as the Core, driving traditional industry towards Green, High-Value, Circular transformation.",
            items: {
                circular: {
                    title: 'Green & Low-Carbon, Leading the Circular Economy',
                    content: `Leveraging bamboo's renewability and fast carbon sequestration, we build a full "Bamboo Resource - Clean Pulping - Bio-Based Materials - Low-Carbon Products" chain, achieving "Zero Waste, Full Utilization" to support China's 30/60 Carbon Goals.`
                },
                innovation: {
                    title: 'Tech Innovation Drives High-Value Conversion',
                    content: 'Breaking bamboo fiber high-value utilization tech, and develop plastic-alternatives like degradable packaging and bio-composites, reducing the full lifecycle carbon footprint.'
                },
                rural: {
                    title: 'Ecological Win-Win, Empowering Rural Revitalization',
                    content: 'Through the "Bamboo Base + Green Factory + Community Symbiosis" model, we enhance bamboo carbon sink income, drive upstream-downstream synergy, and unify environmental, economic, and social benefits.'
                },
                cooperation: {
                    title: 'Open Collaboration, Co-building a Sustainable Future',
                    content: 'Collaborating with Research Institutes & Industry Stakeholders to promote bamboo material standards & tech adoption, making " Bamboo Instead of Plastic, Bamboo Instead of Wood" a Global Green Solution.'
                }
            },
            commitment: {
                title: 'Our Commitment:',
                content: "Every bamboo stalk embodies nature-technology symbiosis; every innovation is for earth's and humanity's future."
            }
        },
        cleanProduction: {
            title: 'Clean Production',
            subtitle: 'Guarding Green Waters & Mountains with Innovative Tech, Leading Sustainability with Clean Production',
            description: 'As a Green Pioneer in bamboo pulp papermaking, Yibin Paper prioritizes " Environment First, Green Development ". Through clean processes, resource recycling & low-carbon innovation, we build an efficient, clean, sustainable modern paper industry, delivering green paper solutions for global customers.',
            items: {
                raw: {
                    title: 'Green Raw Materials, Low-Carbon Source',
                    subtitle: '100% Sustainable Bamboo Fiber, Comprehensive Utilization of Production Waste',
                    points: [
                        'Using Fast-Growing Bamboo Resources to Reduce Deforestation',
                        "Bamboo's strong carbon sequestration during growth lowers emissions at the source.",
                        'Exploring comprehensive use pathways for waste like bamboo chips and lime mud ensures efficient resource cycling.'
                    ]
                },
                process: {
                    title: 'Clean Processes, Energy Saving & Consumption Reduction',
                    subtitle: 'Low-Pollution Pulping Tech, Ultra-Low Effluent & Emission Discharge',
                    points: [
                        'Advanced Elemental Chlorine Free (ECF) bleaching and oxygen delignification drastically reduce harmful emissions like AOX.',
                        'Combined techs like anaerobic and aerobic biological treatment ensure compliant wastewater discharge; reclaimed water is reused for raw material washing, reducing freshwater use.',
                        'Equipped with Recovery Boiler + ESP + Wet Desulfurization Systems, ensuring flue gas emissions exceed national standards.'
                    ]
                },
                recycle: {
                    title: 'Circular Economy, Waste to Resource',
                    subtitle: '100% Black Liquor Recovery, Sludge Valorization, Waste Heat Reuse',
                    points: [
                        'Pulping waste liquor converted to heat & chemicals via recovery system (>85% Self-Sufficiency), reducing fossil fuel reliance',
                        'Paper sludge used for organic fertilizer or biofuel, achieving "Zero Landfill" for solid waste.',
                        'Waste heat from production used for power generation, boosting energy efficiency.'
                    ]
                },
                product: {
                    title: 'Green Products, Low-Carbon Living',
                    subtitle: 'Degradable Packaging Paper, FSC® Certified Products',
                    points: [
                        'Bamboo fiber food-grade packaging paper replaces plastics, reducing "white pollution".',
                        'Ensuring paper sources meet international sustainable forest management standards for high-end markets.'
                    ]
                }
            }
        },
        circularEconomy: {
            title: 'Circular Economy',
            subtitle: 'Bamboo Fully Utilized, Endlessly Renewable',
            imageAlt: 'Circular Economy Model Diagram',
            intro: {
                title: 'Bamboo Replaces Wood, Green Empowers',
                content: 'Advocating efficient bamboo use, we created the integrated "Bamboo-Pulp-Paper-Energy-Fertilizer" circular economy model, unleashing green energy from every bamboo stalk.'
            },
            items: {
                source: {
                    title: 'Green Start: Sustainable Bamboo Source',
                    points: [
                        ' Established ecological bamboo demonstration bases with rotational harvesting management.',
                        'Bamboo grows fast (matures in 3-5 years),, sequesters 1.5x More CO₂ Than chinese fir trees.',
                        'Boosts uncome for 100,000 bamboo farmers, turning " Lucid Waters & Lush Mountains "  into "Gold & Silver Mountains ".'
                    ]
                },
                core: {
                    title: 'Core Cycle: Zero Waste Discharge',
                    points: [
                        'Waste Liquid → Energy: 100% Black Liquor Recovery, Generating 60 Million kWh Annually.',
                        'Waste Gas → Resource: Boiler Flue Gas Waste Heat Reuse Reduces CO₂ Emissions.',
                        'Waste Residue → Carbon Source: Bamboo Residue Converted to Biomass Pellet Fuel.'
                    ]
                },
                upgrade: {
                    title: 'Product Upgrade: Full Bamboo Utilization',
                    points: [
                        ' Premium bamboo pulp food packaging, household paper (FSC® certified).',
                        'Bamboo fiber degradable packaging materials (plastic alternative).',
                        'Bamboo Residue Used for Biomass Fertilizer.'
                    ]
                }
            },
            vision: {
                title: 'Our Vision:',
                content: 'For every bamboo stalk to complete its green journey from carbon sink to product.'
            }
        },
        socialResponsibility: {
            title: 'Social Responsibility',
            subtitle: 'Silent Nurturing, Good Deeds Worldwide',
            tabs: {
                community: 'Community Development',
                farmers: 'Farmer Income Enhancement',
                education: 'Talent Cultivation',
                biodiversity: 'Environmental Stewardship'
            },
            community: {
                title: 'Rural Revitalization Program',
                description: 'Actively responding to national rural revitalization, we drive bamboo industry development in surrounding villages via the "Company + Cooperative + Farmer" model, boosting rural economies.',
                items: {
                    village: {
                        title: 'Village-Based Assistance',
                        content: "We dispatched 2 Party cadres as first secretaries to Shizi Village, Yongxing Town, Cuiping District, and 1 cadre as a team member to Xingwang Village, Yangchun Town, Jiang'an County."
                    },
                    manager: {
                        title: 'Professional Managers for Collective Economy',
                        content1: 'Dispatched 2 key talents as "Professional Managers" to villages to oversee village finances, standardize systems, expand markets, market products, and nurture business talent, enhancing the standardization, marketization, and professionalism of the collective economy.',
                    },
                    project: {
                        title: 'Xingwen County Dahe Miao Township Win-Win Industry Development Partnership (1-to-1 Linkage)',
                        content: 'Per the Yibin City "Enterprise-Nationality Township Win-Win 1-to-1 Linkage Mechanism," we partnered with Dahe Miao Township, Xingwen County, to resolve bamboo raw material sales difficulties.'
                    }
                }
            },
            farmers: {
                title: 'Farmer Income Enhancement Project',
                description: 'We established stable partnerships with local bamboo farmers, helping increase income and achieve common prosperity through direct sourcing, investing in smart equipment, and promoting scientific breeding.',
                imageAlt: 'Farmer Income Enhancement Project',
                items: {
                    direct: {
                        title: 'Direct Sourcing Cuts Intermediaries, Protects Farmer Interests',
                        content1: 'Breaking traditional procurement, we established direct sourcing models like "Company + Specialized Cooperative Yard + Farmers" and "Company + Self-built Yard + Farmers".',
                        content2: 'Deepening primary-secondary industry cooperation cuts out middlemen, optimizes costs, secures supply, facilitates sales, stabilizes prices, and protects farmers.'
                    },
                    tech: {
                        title: 'Tech Empowers Industry Upgrade, Boosts Farmer Income',
                        content1: 'Investing in smart equipment for bamboo harvesting and transport machinery R&D.',
                        content2: 'Significantly improving harvesting/transport efficiency, freeing labor, lowering costs, and sharing tech benefits with farmers to increase income.',
                        content3: 'Demonstrating scientific breeding, planting, and management for high-yield bamboo forest models.',
                        content4: 'Guiding farmers in scientific planting to lower costs, increase yield per mu, and boost income.'
                    },
                    value: {
                        title: 'Value-Added Partnerships Expand Channels, Boost Overall Income',
                        content1: 'Exploring diverse models to unlock "non-timber income" from bamboo forests, piloting carbon credit trading with third parties, allowing farmers extra dividends based on management performance.',
                        content2: 'Guiding under-forest farming to enhance overall income; combining under-forest economy with carbon management boosts carbon sequestration and farmer income, achieving "ecology + economy" wins.'
                    }
                }
            },
            education: {
                title: 'Bamboo&Talent Cultivation Plan',
                description: 'Talent is the core engine for development. We prioritize cultivation through diverse mechanisms to nurture future industry leaders.',
                imageAlt: 'Talent Cultivation Programs',
                items: {
                    mechanism: {
                        title: 'Diverse Talent Cultivation Mechanisms',
                        content: 'Mechanisms like "Mentorship," talent pipelines, job rotation, and customized training help employees evolve from newcomers to industry elites.'
                    },
                    path: {
                        title: 'Refined Career Paths',
                        content: 'Continuous improvement of promotion channels and diverse paths allows everyone to excel in their strengths and grow with the company.'
                    }
                }
            },
            biodiversity: {
                title: 'Green Factory Plan',
                description: 'Actively supporting national "Dual Carbon" goals, we prioritize sustainability and continuously optimize our environmental management system.',
                imageAlt: 'Eco-Friendly Projects',
                items: {
                    policy: {
                        title: '"Bamboo Instead of Wood" "Bamboo Instead of Plastic"',
                        content: 'Actively responding to government calls to replace wood and plastic with bamboo, reducing impact on natural resources, transitioning to a low-carbon economy, and achieving economic & environmental wins.'
                    },
                    factory: {
                        title: 'Green Factory',
                        content: 'Certified FSC FM/CoC, recognized as National "Green Factory," Sichuan "Clean Production" enterprise, products awarded "Sichuan Energy Conservation & Environmental Protection Brand Excellence Product Award".'
                    }
                }
            }
        },
        report: {
            title: 'Sustainability Reports',
            subtitle: 'Transparent, Authentic, Comprehensive Sustainability Disclosure',
            download: 'Download Report',
            items: {
                '2024': {
                    title: '2024 Sustainability Report',
                    date: 'Release Date: April 2024',
                    imageAlt: '2024 Sustainability Report'
                },
                '2023': {
                    title: '2023 Sustainability Report',
                    date: 'Release Date: April 2023',
                    imageAlt: '2023 Sustainability Report'
                }
            }
        },
        cta: {
            title: 'Join Us in Co-Creating a Sustainable Future',
            description: "Learn more about Yibin Paper's sustainability practices or partner with us to advance green development.",
            buttonText: 'Contact Us'
        }
    },
    home: {
        advantages: {
            title: "Our Strengths",
            subtitle: "Bamboo Pulp Papermaking: Eco-Technology, Superior Quality",
            items: {
                experience: {
                    title: "Profound Industry Experience",
                    description: "80 years of technical expertise. A complete pulp & paper and supporting industrial chain providing solid technical support for green, low-carbon bio-based material transformation."
                },
                production: {
                    title: "Mature & Scalable Production System",
                    description: "Comprehensive production facilities & automated lines enable rapid response to customer needs and cost-effective, high-efficiency mass production."
                },
                innovation: {
                    title: "Collaborative R&D Innovation (Industry-University-Research)",
                    description: "Joint labs with universities & research institutes focus on low-carbon processes and renewable materials R&D, accelerating industrialization of cutting-edge technologies like bio-based materials."
                },
                certification: {
                    title: "Full-Chain Green Certifications",
                    description: "Certifications (FSC, Healthcare Grade, Hygiene & Safety Products) covering raw material sourcing to production enhance product market competitiveness."
                }
            }
        },
        products: {
            title: "Main Products",
            subtitle: "Premium Bamboo Pulp Paper Products for Diverse Needs",
            items: {
                bambooPulp: {
                    title: "Virgin Bamboo Pulp",
                    description: "Selected Bamboo Species, Premium Bamboo Fiber",
                    alt: "Bamboo Pulp"
                },
                packagingPaper: {
                    title: "Virgin Bamboo Pulp Packaging Paper",
                    description: "High Strength, Excellent Foldability, Superior Cleanliness",
                    alt: "Packaging Paper"
                },
                culturalPaper: {
                    title: "Virgin Bamboo Pulp Cultural Paper",
                    description: "Smooth & Fine Texture, Superior Writing & Printing Experience",
                    alt: "Cultural Paper"
                },
                livingPaper: {
                    title: "Virgin Bamboo Pulp Household Base Paper",
                    description: "Wet Strength & Durability, Green & Eco-Friendly",
                    alt: "Household Base Paper"
                },
                finishedPaper: {
                    title: "Virgin Bamboo Pulp Finished Household Paper",
                    description: "Soft, Strong & Comfortable, Healthy & Naturally Antibacterial",
                    alt: "Finished Household Paper"
                },
                fiberMaterial: {
                    title: "Fiber Materials",
                    description: "Versatile Functionality for Specialized Needs",
                    alt: "Fiber Materials"
                },
                learnMore: "Learn More"
            }
        },
        about: {
            title: "About Yibin Paper",
            description1: "Yibin Paper Co., Ltd., founded in 1944, is a leading chinese bamboo pulp paper producer, specializing in bamboo pulping and papermaking R&D and production.",
            description2: "Located in Yibin City, Sichuan, with abundant bamboo resources and advanced equipment, our annual capacity exceeds 500,000 tons of high-quality bamboo pulp paper.",
            description3: "We are committed to technological innovation and green production, we provide premium eco-friendly paper products while promoting sustainable development in the paper industry.  ",
            learnMore: "Learn More"
        },
        sustainability: {
            title: "Sustainability",
            subtitle: "Bamboo Pulp Papermaking, Green Cycle",
            items: {
                renewable: {
                    title: "Renewable Bamboo Source",
                    description: "Bamboo matures in 3-5 years, growing rapidly, making it an ideal renewable papermaking raw material."
                },
                carbon: {
                    title: "Carbon Sink Contribution",
                    description: "Bamboo forests absorb more CO₂ than forests of equal area, effectively mitigating climate change."
                },
                clean: {
                    title: "Clean Production",
                    description: "Employs closed-loop production processes with wstewater treatment & reuse for energy saving & emission reduction"
                },
                rural: {
                    title: "Rural Revitalization",
                    description: "Boosting bamboo farmer income, promoting local economic development, achieving ecological and economic wins."
                }
            }
        },
        cta: {
            title: "Partner with Us to Co-Create a Green Future",
            description: "We look forward to providing you with premium bamboo pulp paper products and professional services.",
            buttonText: "Contact Us"
        }
    },
    contact: {
        banner: {
            title: 'Contact Us',
            subtitle: 'Your inquiries and feedback are always welcome.'
        },
        contactInfo: {
            title: 'Contact Information',
            subtitle: 'Your inquiries and feedback are always welcome.',
            address: {
                title: 'Address',
                content: 'Peishi Light Industrial Park, Nanxi District, Yibin, Sichuan Province',
                postcode: 'Postcode: 644100'
            },
            phone: {
                title: 'Telephone',
                main: 'Main: +86-0831-3309663',
                service: 'Customer Service: +86-0831-3309698'
            },
            email: {
                title: 'Email',
                service: 'Customer Service：ybzy@yb-zy.com',
                inquiry: 'Product Inquiry：ybzy@yb-zy.com'
            },
            workingHours: {
                title: 'Business Hours',
                weekday: 'Mon-Fri: 9:00 AM - 5:30 PM',
                holiday: 'Closed on Public Holidays'
            }
        },
        inquiry: {
            title: 'Online Inquiry',
            subtitle: ' Fill out the form below, and we will contact you shortly.',
            form: {
                name: 'Your Name',
                company: 'Company Name',
                email: 'Email',
                phone: 'Phone',
                subject: 'Inquiry Subject',
                subjectPlaceholder: 'Please Select Inquiry Subject',
                subjects: {
                    product: 'Product Inquiry',
                    price: 'Quotation Inquiry',
                    technical: 'Technical Support',
                    cooperation: 'Business Cooperation',
                    other: 'Other Questions'
                },
                message: 'Inquiry Details',
                submit: 'Submit',
                submitting: 'Submitting...'
            },
            sales: {
                title: 'Sales Service',
                domesticRawPaper: 'Domestic Sales (Base Paper)',
                domesticFinishedPaper: 'Domestic Sales (Finished Paper)',
                international: 'International Sales',
                email: 'Sales Email'
            },
            afterSales: {
                title: 'After-Sales Service',
                hotlineRawPaper: 'Service Hotline (Base Paper)',
                hotlineFinishedPaper: 'Service Hotline (Finished Paper)',
                email: 'Service Email'
            },
            social: {
                title: 'Follow Us',
                wechat: 'Official WeChat',
                weibo: 'Official Weibo',
                linkedin: 'LinkedIn'
            }
        },
        location: {
            title: 'Location',
            subtitle: 'Welcome to Visit',
            mapAlt: 'Map Location: Yibin Paper Co., Ltd.',
            transport: {
                public: {
                    title: 'Public Transport',
                    content: 'Bus: Take Nanxi Bus Line 10 [Zhongba Line] to "Yibin Paper" stop.'
                },
                driving: {
                    title: 'Driving Directions',
                    content: "Navigate to 'Yibin Paper Co., Ltd.' - Visitor Parking Available"
                },
                airport: {
                    title: 'Airport Transport',
                    content: 'Yibin Wuliangye Airport (~58 km): take airport shuttle bus or taxi.'
                }
            }
        },
        offices: {
            title: '全球办事处',
            subtitle: '国际化服务网络',
            china: {
                title: '中国总部',
                flagAlt: '中国国旗',
                address: '四川省宜宾市翠屏区岷江西路159号',
                phone: '电话：0831-12345678'
            },
            usa: {
                title: '北美代表处',
                flagAlt: '美国国旗',
                address: '美国加利福尼亚州洛杉矶市橡树大道2588号',
                phone: '电话：+1-213-888-9999'
            },
            japan: {
                title: '日本代表处',
                flagAlt: '日本国旗',
                address: '日本东京都千代田区丸之内1-2-3',
                phone: '电话：+81-3-1234-5678'
            },
            europe: {
                title: '欧洲代表处',
                flagAlt: '德国国旗',
                address: '德国汉堡市汉萨街456号',
                phone: '电话：+49-40-8765-4321'
            },
            singapore: {
                title: '东南亚代表处',
                flagAlt: '新加坡国旗',
                address: '新加坡莱佛士码头10号',
                phone: '电话：+65-6789-0123'
            }
        },
        faq: {
            title: 'FAQs',
            subtitle: 'Quick Answers to Your Questions'
        },
        cta: {
            title: 'We look forward to hearing from you',
            description: 'Whatever Your Questions or Needs, We Are Here to Serve You',
            buttonText: 'Contact Us Now'
        }
    }
} 